import { RoutesEnum } from '~/enums'
import { SCROLL_DELAY_MS } from '~/constants'

export const useScrollToTopWinner = () => {
  let timeOut: ReturnType<typeof setTimeout> | null = null

  const route = useRoute()
  const router = useRouter()

  const scrollToTopWinners = () => {
    const element = document.getElementById('top-winners')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  const onScrollToTopWinner = () => {
    if (route.path === RoutesEnum.Home) {
      scrollToTopWinners()
    } else {
      router.push(RoutesEnum.Home)

      timeOut = setTimeout(() => {
        scrollToTopWinners()
      }, SCROLL_DELAY_MS)
    }
  }

  onBeforeUnmount(() => {
    if (timeOut) {
      clearTimeout(timeOut)
    }
  })

  return { onScrollToTopWinner }
}
